import {AccessArea} from 'Common/permissions/AccessArea';
import {Role} from 'Common/permissions/Role';
import {BrowserOrServerId} from 'Browser/BrowserId';

export class PublicRole extends Role<BrowserOrServerId>
{
	constructor()
	{
		super('public');
	}

	public toJson()
	{
		return {
			type: this.name
		};
	}

	public topAccess(): AccessArea
	{
		return new AccessArea('unrestricted');
	}

	public canAccessArea(area:AccessArea)
	{
		return (new AccessArea('unrestricted')).includes(area);
	}
}

